import { AppTheme } from '../types';

const storeKey = 'theme';

export default {
    setTheme(payload: AppTheme) {
        const root = document.documentElement;
        root.className = payload;
        if (root.getAttribute('data-prefers-color')) {
            root.setAttribute('data-prefers-color', payload);
        }
        window.localStorage.setItem(storeKey, payload);
        return payload;
    },
    getTheme() {
        const theme = window.localStorage.getItem(storeKey);
        if (theme === AppTheme.dark) {
            return AppTheme.dark;
        } else if (theme === AppTheme.xdesign) {
            return AppTheme.xdesign;
        }
        return AppTheme.white;
    },
};
